import React, { PureComponent } from 'react';
import './styles.scss';

class ErrorAdvice extends PureComponent {
    state = {};

    render() {
        const { className, children } = this.props;
        return <div className={`fm-advice fm-advice-error ${className}`}>{children}</div>;
    }
}

export default ErrorAdvice;
